console.log("Zero Waste Script Loaded");

document.addEventListener("DOMContentLoaded", function () {
  var zeroWasteWrapper = document.getElementById("zeroWasteWrapper");
  var zeroWasteOverlay = document.getElementById("zeroWasteOverlay");
  var zeroWasteModal = document.getElementById("zeroWasteModal");
  var zeroWasteItemImage = document.getElementById("zeroWasteItemImage");
  var zeroWasteOrderImage = document.getElementById("zeroWasteOrderImage");
  var zeroWasteTrigger = document.querySelector(".zeroWasteTrigger"); // If there's a trigger button
  var zeroWasteNoThanks = document.getElementById("zeroWasteNoThanks"); // No Thanks button

  if (!zeroWasteWrapper || !zeroWasteModal) {
    console.warn("Zero Waste Modal elements not found on the page.");
    return;
  }

  // Ensure modal is hidden initially
  zeroWasteWrapper.style.display = "none";

  // Function to open the modal
  function openZeroWasteModal() {
    zeroWasteWrapper.style.display = "flex"; // Show the modal
  }

  // Function to close the modal
  function closeZeroWasteModal() {
    zeroWasteWrapper.style.display = "none"; // Hide the modal
  }

  // **Expose these functions globally so our interception code can call them**
  window.openZeroWasteModal = openZeroWasteModal;
  window.closeZeroWasteModal = closeZeroWasteModal;

  // Attach event listener for overlay (click to close)
  zeroWasteOverlay.addEventListener("click", closeZeroWasteModal);

  // Add a close button dynamically
  var closeButton = document.createElement("button");
  closeButton.innerText = "✖";
  closeButton.style.position = "absolute";
  closeButton.style.top = "10px";
  closeButton.style.right = "15px";
  closeButton.style.background = "transparent";
  closeButton.style.border = "none";
  closeButton.style.fontSize = "20px";
  closeButton.style.cursor = "pointer";
  closeButton.addEventListener("click", closeZeroWasteModal);
  zeroWasteModal.appendChild(closeButton);

  // Check if a trigger button exists and add click event
  if (zeroWasteTrigger) {
    zeroWasteTrigger.addEventListener("click", openZeroWasteModal);
  }

  // Handle Zero Waste Item Selection
  if (zeroWasteItemImage) {
    zeroWasteItemImage.addEventListener("click", function () {
      this.classList.add("active-button");
      updateCartProperties("Ship this item with zero waste.");
    });
  }

  if (zeroWasteOrderImage) {
    zeroWasteOrderImage.addEventListener("click", function () {
      this.classList.add("active-button");
      updateCartProperties("Ship this entire order with zero waste.");
    });
  }

  function updateCartProperties(optionText) {
    fetch("/cart.js")
      .then(response => response.json())
      .then(cart => {
        if (cart.items.length === 0) return;

        let lastItem = cart.items[0];
        let lastItemProperties = lastItem.properties || {};
        lastItemProperties.zeroWasteOption = optionText;

        fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ line: 1, properties: lastItemProperties })
        })
        .then(response => response.json())
        .then(() => {
          console.log("Updated cart properties successfully:", optionText);
          window.location.href = "/cart";
        });
      });
  }

  // ✨ New "No Thanks" button functionality ✨
  if (zeroWasteNoThanks) {
    zeroWasteNoThanks.addEventListener("click", function (event) {
      event.preventDefault(); // Prevents the page from reloading
      closeZeroWasteModal(); // Closes the modal
    });
  }

});

// Ensure ReCharge can call this function
window.RechargeBundle = {
  onAddToCart: () => {
    console.log("onAddToCart called - Showing Zero Waste Modal");
    document.getElementById("zeroWasteWrapper").style.display = "flex";
  }
};